// extracted by mini-css-extract-plugin
export default {"textBlock":"_3dCNyTSnNmCnD44RhI8WGt"};